



























import { IHeightStyle } from "@/@types/styles/height";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class MainDemo extends Vue {
  show = false;
  menuDemoHeightStyle: IHeightStyle = {
    minHeight: "auto",
    maxHeight: "auto",
  };

  $refs!: {
    menuDemo: HTMLElement;
    menuDemoHeaderFooter: HTMLElement;
  };

  async calculateHeight(): Promise<void> {
    const headerFooter = this.$refs.menuDemoHeaderFooter.clientHeight;
    const fullHeight = this.$refs.menuDemo.clientHeight;
    const mainHeight = fullHeight - 2 * headerFooter;
    this.menuDemoHeightStyle.minHeight = mainHeight + "px";
    this.menuDemoHeightStyle.maxHeight = this.menuDemoHeightStyle.minHeight;
    sessionStorage.setItem("demo-height", String(mainHeight));
    console.log(mainHeight);
    this.show = true;
  }

  mounted(): void {
    window.addEventListener("resize", this.calculateHeight);
    setTimeout(() => this.calculateHeight(), 200);
  }

  destroyed(): void {
    window.removeEventListener("resize", this.calculateHeight);
  }
}
